import { useLocale } from "next-intl";
import { useTransition } from "react";

import { usePathname, useRouter } from "@/i18n/navigation";

export function useChangeLocale() {
  const [isPending, startTransition] = useTransition();
  const router = useRouter();
  const pathname = usePathname();
  const _currentLocale = useLocale();

  const changeLocale = (newLocale: string) => {
    // Set NEXT_LOCALE cookie so middleware respects the choice
    document.cookie = `NEXT_LOCALE=${newLocale}; path=/; max-age=31536000; SameSite=Lax`;

    startTransition(() => {
      // Use router.replace with the new locale
      // The pathname is already locale-agnostic when using next-intl's usePathname
      // Keep the query string: a link like /agents/approve?code=… must still carry its code in the new language
      router.replace(`${pathname}${window.location.search}`, { locale: newLocale });
    });
  };

  return { changeLocale, isPending };
}
